import React, { useState } from 'react';
import { Container, Divider, Grid, useMediaQuery } from '@mui/material';
import RedirectStore from './RedirectStore';
import SingleProductDesktop from './SingleProductDesktop';
import SingleProductMobile from './SingleProductMobile';
import WhoPurchased from './WhoPurchased';

const SingleProduct = ({
  products,
  registryId,
  fetchRegistryData,
  type,
  loading,
}) => {
  const [openRedirectModal, setOpenRedirectModal] = useState(false);
  const [openPurchaseModal, setOpenPurchaseModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [storeName, setStoreName] = useState(null);

  const handleBuyNow = (url, store) => {
    setRedirectUrl(url);
    setStoreName(store);
    setOpenRedirectModal(true);
  };

  const handlePurchaseForm = (isChecked) => {
    if (isChecked) {
      setOpenPurchaseModal(true);
    }
  };

  const isSmallScreen = useMediaQuery('(max-width:800px)');

  return (
    <>
      <Container>
        {products &&
          products.map((product) => (
            <Grid
              key={product.id}
              container
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 2,
                bgcolor: '#ffffff',
                border: '1px solid #000000',
                padding: { xs: '16px', md: '0px' },
                my: { xs: '24px', sm: '40px', md: '80px' },
                maxHeight: type === 'purchased' ? '230px' : '480px',
              }}>
              <Grid
                item
                xs={4}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: {
                    xs: '120px',
                    md: type === 'purchased' ? '150px' : '400px',
                  },
                  height: {
                    xs: '120px',
                    md: type === 'purchased' ? '150px' : '400px',
                  },
                  pr: { sm: '20px', md: '40px' },
                  p: type !== 'purchased' && { md: '40px' },
                  my: type === 'purchased' && { md: '40px' },
                }}>
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    flexShrink: 0,
                    overflow: 'hidden',
                  }}>
                  {loading || product?.product_details?.pictures.length > 0 ? (
                    <img
                      src={
                        product?.product_details?.pictures[0] ||
                        '/default_product_category.png'
                      }
                      loading="lazy"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        maxWidth: '100%',
                        maxHeight: '100%',
                      }}
                      alt="Product"
                      onError={(e) => {
                        e.target.src = '/default_product_category.png';
                      }}
                    />
                  ) : (
                    <img
                      src="/default_product_category.png"
                      loading="lazy"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        maxWidth: '100%',
                        maxHeight: '100%',
                      }}
                      alt="Default Product"
                    />
                  )}
                </div>
              </Grid>
              {!isSmallScreen && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ borderColor: 'black', opacity: 1 }}
                />
              )}
              {isSmallScreen ? (
                <SingleProductMobile
                  product={product}
                  handleBuyNow={handleBuyNow}
                  handlePurchaseForm={handlePurchaseForm}
                  setSelectedProduct={setSelectedProduct}
                  type={type}
                  selectedProduct={selectedProduct}
                />
              ) : (
                <SingleProductDesktop
                  product={product}
                  handleBuyNow={handleBuyNow}
                  handlePurchaseForm={handlePurchaseForm}
                  setSelectedProduct={setSelectedProduct}
                  type={type}
                  selectedProduct={selectedProduct}
                />
              )}
            </Grid>
          ))}
        {openRedirectModal && (
          <RedirectStore
            open={openRedirectModal}
            url={redirectUrl}
            storeName={storeName}
            onClose={() => setOpenRedirectModal(false)}
          />
        )}
        {openPurchaseModal && (
          <WhoPurchased
            open={openPurchaseModal}
            onClose={() => setOpenPurchaseModal(false)}
            setSelectedProduct={setSelectedProduct}
            product={selectedProduct}
            registryId={registryId}
            fetchRegistryData={fetchRegistryData}
            selectedProduct={selectedProduct}
          />
        )}
      </Container>
    </>
  );
};

export default SingleProduct;
